'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024189 from "./presto.types$$anon$189.js";
import * as $j_presto$002etypes$0024$0024anon$0024190 from "./presto.types$$anon$190.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$188() {
  this.c3a = null;
  this.c38 = null;
  this.c39 = false;
  this.c36 = null;
  this.c37 = false;
  this.c3b = false;
  this.c3c = false;
  this.c3a = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$$anon$188 as $c_Lpresto_types$$anon$188 };
$p = $c_Lpresto_types$$anon$188.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$188;
/** @constructor */
function $h_Lpresto_types$$anon$188() {
}
export { $h_Lpresto_types$$anon$188 as $h_Lpresto_types$$anon$188 };
$h_Lpresto_types$$anon$188.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.c3a;
});
$p.t = (function() {
  if ((!this.c39)) {
    this.c38 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("starts", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ends", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.c39 = true;
  }
  return this.c38;
});
$p.ag = (function() {
  if ((!this.c37)) {
    this.c36 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002etypes$0024$0024anon$0024189.$c_Lpresto_types$$anon$189(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002etypes$0024$0024anon$0024190.$c_Lpresto_types$$anon$190(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.c37 = true;
  }
  return this.c36;
});
$p.v = (function() {
  if ((!this.c3c)) {
    this.c3b = false;
    this.c3c = true;
  }
  return this.c3b;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_types$$anon$188 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$188, "presto.types$$anon$188", ({
  Yg: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$188 as $d_Lpresto_types$$anon$188 };
//# sourceMappingURL=presto.types$$anon$188.js.map
